// frontend/src/hooks/useSiteWeather.js
import { useQuery } from '@tanstack/react-query';
import { staffAPI } from '../services/api';

/**
 * Live NEA weather + heat/UV advisory across active worksites.
 * Backed by data.gov.sg real-time API (cached ~10 min server-side), so a
 * 10-minute client staleTime avoids redundant refetches.
 */
export const useSiteWeather = () => {
  return useQuery({
    queryKey: ['weather', 'sites'],
    queryFn: async () => {
      const response = await staffAPI.getSiteWeather();
      return response.data;
    },
    staleTime: 10 * 60 * 1000,
    refetchOnWindowFocus: true,
    refetchInterval: 10 * 60 * 1000,
    retry: 1,
  });
};

export default useSiteWeather;
